// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"BackgroundIsGradient_boxStyle__10Iuy"};